import Typography from '@mui/material/Typography';
import { useForgotPassword } from 'features/user';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { LoginLogo } from 'shared/components/ui/login-logo';
import { Paths } from 'shared/routes';

import { ForgotPasswordForm } from './components/forgot-password-form';
import * as Styled from './forgot-password.style';

export const ForgotPassword: React.FC = () => {
  const { t } = useTranslation();
  const { forgotPassword, isLoading, error, isSuccess } = useForgotPassword();

  return (
    <Styled.Container>
      <Styled.Body>
        <Styled.BodyContent>
          <LoginLogo />

          <Typography variant="h1" textAlign="center">
            {t('forms.forgot-password.title')}
          </Typography>

          {isSuccess ? (
            <Typography variant="body2">
              {t('forms.forgot-password.success.message')}
            </Typography>
          ) : (
            <ForgotPasswordForm
              onSubmit={forgotPassword}
              isLoading={isLoading}
              error={error ?? undefined}
            />
          )}

          <Styled.Anchor to={Paths.Login}>
            {t('forms.forgot-password.back-to-login.label')}
          </Styled.Anchor>
        </Styled.BodyContent>
      </Styled.Body>
    </Styled.Container>
  );
};
